import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@rocketseat/unform';
import produce from 'immer';

import { Title, Stepper, Breadcrumbs } from '@unimed-fesp/components';

import { Creators as UsuarioActions } from '../../store/ducks/usuario';
import history from '../../services/history';

// #region  Enums
import { TipoCardRoot } from '../../enums';
import TipoTelefoneEnum from '../../enums/TipoTelefoneEnum';
import PermissaoContratanteEnum from '../../enums/PermissaoContratanteEnum';
// #endregion

import {
  isEmail,
  isValidMesmoCelular,
  isValidMesmoTelefone,
} from '../../utils/validation';
import { getParametrizacaoRoot } from '../../utils/treeViewBuilder';

import theme from '../../styles/theme';
import { Container, HeaderWrapper } from './styles';

// #region Componentes
import Parametros from './Parametros';
import DadosGerais from './DadosGerais';
import DadosAcesso from './DadosAcesso';
// #endregion

function UsuarioNovo({ match }) {
  const dispatch = useDispatch();
  const { perfilNovoUsuario } = match.params;

  const { newUsuario, error, usuarioEspelho } = useSelector(
    (state) => state.usuario
  );
  const { idUsuarioLogado } = useSelector((state) => state.auth.usuario);
  const { parametrizacaoRoot } = useSelector((state) => state.contratante);

  const [selectedPermissao, setSelectedPermissao] = useState(
    'Selecione a permissão'
  );
  const [selectedTipoInfo, setSelectedTipoInfo] = useState({
    tipo: '',
    mask: [],
    placeholder: 'Selecione o tipo',
  });
  const [secondSelectedTipoInfo, setSecondSelectedTipoInfo] = useState({
    tipo: '',
    mask: [],
    placeholder: 'Selecione o tipo',
  });
  const editarUsuarioParam = {
    nome: '',
    matricula: '',
    codigoContratante: '',
    tipoPerfilUsuario: '',
    tipoPermissaoUsuario: '',
    tipoStatusUsuario: '',
    email: '',
  };

  const editarContatosParams = {
    contatos: [
      {
        tipo: TipoTelefoneEnum.returnNameForName.Residencial,
        numero: '',
      },
    ],
  };

  const [usuarioParams, setUsuarioParams] = useState(editarUsuarioParam);
  const [contatoParams, setContatoParams] = useState(editarContatosParams);
  const [openModalCancelAction, setOpenModalCancelAction] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [camposPreenchidos, setCamposPreenchidos] = useState({
    nome: false,
    contato: false,
  });
  const [activeTab, setActiveTab] = useState({
    dadosGerais: true,
    dadosAcesso: false,
    parametrizacao: false,
  });
  const [liberarAcesso, setLiberarAcesso] = useState(false);
  const [openModalLiberarAcesso, setOpenModalLiberarAcesso] = useState(false);
  const [isButtonSaveDisabled, setIsButtonSaveDisabled] = useState(true);
  const [addNewUser, setAddNewUser] = useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalError, setOpenModalError] = useState({
    error: false,
    message: '',
  });
  const [dadosGeraisCompleted, setDadosGeraisCompleted] = useState(false);
  const [parametrizacaoCompleted, setParametrizacaoCompleted] = useState(false);
  const [dadosAcessoCompleted, setDadosAcessoCompleted] = useState(false);

  function handleAvancarTab() {
    if (perfilNovoUsuario === 'Administrador') {
      setActiveTab({
        dadosGerais: false,
        dadosAcesso: true,
        parametrizacao: false,
      });
    } else if (activeTab.dadosGerais) {
      setActiveTab({
        dadosGerais: false,
        dadosAcesso: false,
        parametrizacao: true,
      });
    } else {
      setActiveTab({
        dadosGerais: false,
        dadosAcesso: true,
        parametrizacao: false,
      });
    }
  }

  function handleChangeTipo(e) {
    const newSelectedTipo = produce(selectedTipoInfo, (draft) => {
      draft.tipo = e.target.dataset.text;
      return draft;
    });

    setSelectedTipoInfo(newSelectedTipo);
  }

  function handleChangeNome(e) {
    const newCamposPreenchidos = produce(camposPreenchidos, (draft) => {
      draft.nome = usuarioParams.nome !== '';
      return draft;
    });

    setCamposPreenchidos(newCamposPreenchidos);
  }

  function handleModalCancelAction() {
    setOpenModalCancelAction(!openModalCancelAction);
  }

  function handleSelectedPermissao(e) {
    setSelectedPermissao(e.target.dataset.text);
  }

  const handleCancelarCadastro = useCallback(() => {
    history.push(`/novo/gestao`);
  }, []);

  function handleSubmit(data) {
    setOpenModalLiberarAcesso(false);
    if (liberarAcesso) data.tipoStatusUsuario = 'Ativo';
    else data.tipoStatusUsuario = 'PendenteLiberacao';

    if (data.tipoPerfilUsuario === 'Administrador')
      data.tipoPerfilUsuario = 'Adm';
    else {
      data.tipoPerfilUsuario =
        PermissaoContratanteEnum.returnTipoPerfilUsuarioForPermissao[
          data.tipoPermissaoUsuario
        ];

      const newCards = [];
      parametrizacaoRoot.map((card) => {
        const { contagem, parametrizacaoRoot } = getParametrizacaoRoot(card);
        if (card.idParametrizacao === 0) {
          newCards.push({
            idParametrizacao: 0,
            idUsuarioInclusao: idUsuarioLogado,
            tipoParametrizacao:
              TipoCardRoot.returnNameForName[card.tipoParametrizacao],
            parametrizacaoRoot,
          });
        }
      });

      data.cards = newCards;
    }

    data.contato.map((c) => {
      const numero = c.numero.replace(/\D/gi, '');
      c.ddd = numero.substring(0, 2);
      c.numero = numero.substring(2);
    });

    dispatch(UsuarioActions.criarUsuarioRequest(data));
  }

  function handleLiberarAcesso() {
    setLiberarAcesso(true);
  }

  function handleModalLiberarAcesso() {
    setOpenModalLiberarAcesso(!openModalLiberarAcesso);
  }

  function handleModalLiberarAcessoNewUser() {
    setOpenModalLiberarAcesso(!openModalLiberarAcesso);
    setAddNewUser(true);
  }

  function handleNaoLiberarAcesso() {
    setLiberarAcesso(false);
  }

  function handleModalSuccess() {
    dispatch(UsuarioActions.criarUsuarioRenew());
    setOpenModalSuccess(false);

    if (addNewUser) {
      setUsuarioParams(editarUsuarioParam);
      setContatoParams(editarContatosParams);
      setActiveTab({
        dadosGerais: true,
        dadosAcesso: false,
      });
      setAddNewUser(false);
    } else {
      history.push(`/novo/gestao`);
    }
  }
  function handleModalError() {
    dispatch(UsuarioActions.criarUsuarioRenew());
    setOpenModalError({ error: false, message: '' });
  }

  function isValidContato(contato, tipo) {
    const validContato = {
      Residencial: isValidMesmoTelefone(contato),
      Celular: isValidMesmoCelular(contato),
    };

    return validContato[tipo];
  }

  function isValidEmail(email) {
    const validEmail = isEmail(email);

    return validEmail;
  }

  function requiredFields(role) {
    if (role !== 'Administrador') {
      if (
        contatoParams.contatos.some((c) => c.numero !== '') &&
        !contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo))
      )
        return (
          !!usuarioParams.nome &&
          //! !usuarioParams.codigoContratante &&
          !!usuarioParams.tipoPermissaoUsuario &&
          contatoParams.contatos.every((c) => c.numero !== '') &&
          contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo))
        );
      return (
        !!usuarioParams.nome &&
        //! !usuarioParams.codigoContratante &&
        !!usuarioParams.tipoPermissaoUsuario
      );
    }
    if (
      contatoParams.contatos.some((c) => c.numero !== '') &&
      !contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo))
    ) {
      return (
        !!usuarioParams.nome &&
        contatoParams.contatos.every((c) => c.numero !== '') &&
        contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo))
      );
    }

    return !!usuarioParams.nome;
  }

  function requiredFieldsSave() {
    return !!usuarioParams.email && isValidEmail(usuarioParams.email);
  }

  function isRequiredFieldsSet(activeTab) {
    if (activeTab.dadosGerais) return requiredFields(perfilNovoUsuario);
    if (activeTab.dadosAcesso) return requiredFieldsSave();
  }

  function handleActiveTab(tab) {
    if (tab === 'dadosGerais') {
      setActiveTab({
        dadosGerais: true,
        dadosAcesso: false,
        parametrizacao: false,
      });
    } else if (tab === 'dadosAcesso' && requiredFields(perfilNovoUsuario)) {
      setActiveTab({
        dadosGerais: false,
        dadosAcesso: true,
        parametrizacao: false,
      });
      setParametrizacaoCompleted(true);
    } else if (tab === 'parametrizacao' && requiredFields(perfilNovoUsuario)) {
      setActiveTab({
        dadosGerais: false,
        dadosAcesso: false,
        parametrizacao: true,
      });
    }
  }

  function handlePreviousTab(tab) {
    if (tab === 'parametrizacao') {
      setActiveTab({
        dadosGerais: true,
        dadosAcesso: false,
        parametrizacao: false,
      });
    } else if (tab === 'dadosAcesso') {
      setActiveTab({
        dadosGerais: perfilNovoUsuario === 'Administrador',
        dadosAcesso: false,
        parametrizacao: perfilNovoUsuario !== 'Administrador',
      });
    }
  }

  useEffect(() => {
    if (requiredFields(perfilNovoUsuario)) {
      setIsButtonDisabled(false);
      setDadosGeraisCompleted(true);
    } else {
      setIsButtonDisabled(true);
      setDadosGeraisCompleted(false);
    }
  }, [usuarioParams, contatoParams]);

  useEffect(() => {
    if (isRequiredFieldsSet(activeTab)) setIsButtonSaveDisabled(false);
    else setIsButtonSaveDisabled(true);
  }, [usuarioParams]);

  useEffect(() => {
    if (newUsuario.success) setOpenModalSuccess(true);
    else if (newUsuario.isError) {
      setOpenModalError({
        error: true,
        message: newUsuario.error,
      });
    }
  }, [newUsuario.success, newUsuario.isError]);

  useEffect(() => {
    if (!usuarioParams.email && activeTab.dadosAcesso)
      setIsButtonSaveDisabled(true);
  }, [activeTab]);

  useEffect(() => {
    if (requiredFieldsSave()) setDadosAcessoCompleted(true);
    else setDadosAcessoCompleted(false);
  }, [usuarioParams.email]);

  useEffect(() => {
    if (usuarioEspelho?.tipoPerfil && usuarioEspelho.tipoPerfil !== 'Adm') {
      setUsuarioParams((oldState) => ({
        ...oldState,
        tipoPermissaoUsuario:
          PermissaoContratanteEnum.returnPermissaoForTipoPerfilUsuario[
            usuarioEspelho?.tipoPerfil
          ],
      }));
    }
  }, [usuarioEspelho]);

  const CrumbsOptions = [
    { path: 'novo' },
    {
      path: 'gestão de usuários',
      onNavigate: () => history.push('/novo/gestao'),
    },
    {
      path: `cadastrar usuário ${perfilNovoUsuario}`,
      onNavigate: () =>
        history.push(`/novo/gestao/novo-usuario/${perfilNovoUsuario}`),
    },
  ];
  const StepperOptions = [
    {
      completed: dadosGeraisCompleted,
      onClick: () => handleActiveTab('dadosGerais'),
      text: 'dados gerais',
      perfil: ['Contratante', 'Administrador'],
    },
    {
      completed: parametrizacaoCompleted,
      onClick: () => handleActiveTab('parametrizacao'),
      text: 'parametrização',
      disabled: activeTab.dadosGerais && !parametrizacaoCompleted,
      perfil: ['Contratante'],
    },
    {
      completed: dadosAcessoCompleted,
      onClick: () => handleActiveTab('dadosAcesso'),
      text: 'dados de acesso',
      disabled:
        (activeTab.dadosGerais || activeTab.parametrizacao) &&
        !dadosAcessoCompleted,
      perfil: ['Contratante', 'Administrador'],
    },
  ];

  return (
    <Container>
      <Title
        text="cadastrar usuário"
        color={theme.titleGray}
        fontSize={38}
        marginBottom={8}
      />
      <Breadcrumbs crumbs={CrumbsOptions} />
      <HeaderWrapper>
        <Stepper
          steps={StepperOptions.filter((step) =>
            step.perfil.includes(perfilNovoUsuario)
          )}
        />
      </HeaderWrapper>
      <Form onSubmit={handleSubmit}>
        <Parametros
          display={activeTab.parametrizacao ? '' : 'none'}
          handleCancelarCadastro={handleCancelarCadastro}
          handleModalCancelAction={handleModalCancelAction}
          isButtonDisabled={isButtonDisabled}
          openModalCancelAction={openModalCancelAction}
          handlePreviousTab={handlePreviousTab}
          handleActiveTab={handleActiveTab}
        />
        <DadosGerais
          contatoParams={contatoParams}
          setContatoParams={setContatoParams}
          perfilNovoUsuario={perfilNovoUsuario}
          handleChangeNome={handleChangeNome}
          handleSelectedPermissao={handleSelectedPermissao}
          openModalCancelAction={openModalCancelAction}
          handleCancelarCadastro={handleCancelarCadastro}
          handleModalCancelAction={handleModalCancelAction}
          camposPreenchidos={camposPreenchidos}
          handleChangeTipo={handleChangeTipo}
          setUsuarioParams={setUsuarioParams}
          usuarioParams={usuarioParams}
          secondSelectedTipoInfo={secondSelectedTipoInfo}
          selectedTipoInfo={selectedTipoInfo}
          selectedPermissao={selectedPermissao}
          display={activeTab.dadosGerais ? '' : 'none'}
          handleAvancarTab={handleAvancarTab}
          isButtonDisabled={isButtonDisabled}
        />
        <DadosAcesso
          perfilNovoUsuario={perfilNovoUsuario}
          handleSelectedPermissao={handleSelectedPermissao}
          openModalCancelAction={openModalCancelAction}
          handleCancelarCadastro={handleCancelarCadastro}
          handleModalCancelAction={handleModalCancelAction}
          camposPreenchidos={camposPreenchidos}
          handleChangeTipo={handleChangeTipo}
          setUsuarioParams={setUsuarioParams}
          usuarioParams={usuarioParams}
          secondSelectedTipoInfo={secondSelectedTipoInfo}
          selectedTipoInfo={selectedTipoInfo}
          selectedPermissao={selectedPermissao}
          display={activeTab.dadosAcesso ? '' : 'none'}
          nomeValue={usuarioParams.nome}
          isButtonDisabled={isButtonDisabled}
          handleLiberarAcesso={handleLiberarAcesso}
          handleModalLiberarAcesso={handleModalLiberarAcesso}
          openModalLiberarAcesso={openModalLiberarAcesso}
          handleNaoLiberarAcesso={handleNaoLiberarAcesso}
          isButtonSaveDisabled={isButtonSaveDisabled}
          setAddNewUser={setAddNewUser}
          openModalSuccess={openModalSuccess}
          handleModalSuccess={handleModalSuccess}
          openModalError={openModalError}
          handleModalError={handleModalError}
          handleModalLiberarAcessoNewUser={handleModalLiberarAcessoNewUser}
          handlePreviousTab={handlePreviousTab}
        />
      </Form>
    </Container>
  );
}

export default UsuarioNovo;
